import React from 'react'
import { Radio, RadioProps, Typography } from 'antd'
const { Title } = Typography

interface CustomRadioProps extends RadioProps {
  text: string,
  value: any
}

const CustomRadio: React.FC<CustomRadioProps> = ({ text, value, ...restProps }) => {
  return (
    <Radio value={value} {...restProps}>
      <Title level={5} type='secondary'>
        {text}
      </Title>
    </Radio>
  )
}

export default CustomRadio
